import { useQuery } from '@apollo/client/react';

import { GetAgentFeaturePublicationsForSettingsMenuDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { useFeatureFlag } from '~/hooks/use-feature-flag';

export const useFetchAgentFeaturePublications = () => {
  const { data } = useQuery(GetAgentFeaturePublicationsForSettingsMenuDocument, {
    fetchPolicy: 'cache-and-network',
  });
  const printOutpatientQuestionnaireEnabled = useFeatureFlag(
    'Issue14251-print_outpatient_questionnaire',
  );
  const publications = data ? getMe(data)?.organization.company.agentFeaturePublications || [] : [];
  const publishedFeatureCodes = publications
    .filter((publication) => publication.published)
    .map((publication) => publication.featureCode);
  // 段階リリース中は、FF の対象の法人にだけ Web問診自動印刷を出す
  const hasPublishedAgentFeature =
    publishedFeatureCodes.includes('print_prescription') ||
    (publishedFeatureCodes.includes('outpatient_questionnaire') &&
      printOutpatientQuestionnaireEnabled);

  return { hasPublishedAgentFeature };
};
